// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2IOvi","label":"SetPasswdForm_label__eE0Hd"};